import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: 10,
    boxShadow: '0px 3px 9px rgb(0, 0, 0, 0.11)',
    cursor: 'pointer',
  },
  title: {
    margin: 0,
    marginBottom: 20,
    fontSize: 15,
    fontWeight: 600,
    color: theme.custom.darkBlue,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  list: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  text: {
    fontSize: 14,
    fontWeight: 400,
    color: theme.custom.darkBlue,
  },
  green: {
    color: theme.custom.accept,
  },
  red: {
    color: theme.custom.warning,
  },
  status: {
    fontWeight: 600,
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
  },
  wide: {
    flex: 1,
    justifyContent: 'space-between',
  },
  ml5: {
    marginLeft: 5,
  },
}));
